import React, { useContext, useState } from "react";
import { LayoutFlagContext } from "./providers/LayoutFlagProvider";

const Btn = (props) => {
    const { msg, myclass, myicon, mytype, btnFnc } = props;
    //onClickを親から受け取っている

    const {layoutMode, setLayoutMode} = useContext(LayoutFlagContext);

    //表示判定
    let showFlg = true;
    if(msg === ''){
        showFlg = false;
    }

    //表示判定: 戻るボタンの場合
    if(mytype == 'button' && layoutMode !== 'result'){
        showFlg = false;
    }

    //表示判定: 検索するボタンの場合
    if(mytype == 'submit' && layoutMode !== 'initial'){
        showFlg = false;
    }

    if(showFlg) {
        return (
            <div class="search-btn-container">
                <button type={mytype} class={myclass} onClick={btnFnc ? () => btnFnc() : null }>
                    <div class="btn-inner-row">
                        <div class="btn-inner-col">
                            <p>{msg}</p>
                        </div>
                        <div class="btn-inner-col">
                            <div class={myicon}></div>
                        </div>
                    </div>
                </button>
            </div>
        );
    }
};
export default Btn;